<template>
  <aside class="side-menu" :class="{ open: menuOpen }">
    <div class="side-menu__wrapper">
      <div class="side-menu__header">
        <p>Меню</p>
        <svg
          @click="$emit('closeMenu')"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18 18L6 6"
            stroke="#14181F"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M18 6L6 18"
            stroke="#14181F"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
      <nav>
        <ul class="side-menu__nav" :class="{ registration: isProfileRegistration }">
          <li>
            <router-link
              class="side-menu__nav__item catalog"
              @click="$emit('closeMenu')"
              :to="{ name: 'categories' }"
            >
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_2190_36580)">
                  <circle
                    class="stroke"
                    cx="21.7782"
                    cy="19.7783"
                    r="4.75"
                    transform="rotate(-45 21.7782 19.7783)"
                    stroke="#D93030"
                    stroke-width="1.5"
                  />
                  <path
                    class="fill"
                    d="M26.5304 23.4697L26 22.9393L24.9393 24L25.4696 24.5303L26.5304 23.4697ZM28.6725 27.7334C28.9654 28.0263 29.4403 28.0263 29.7332 27.7334C30.0261 27.4406 30.0261 26.9657 29.7332 26.6728L28.6725 27.7334ZM25.4696 24.5303L28.6725 27.7334L29.7332 26.6728L26.5304 23.4697L25.4696 24.5303Z"
                    fill="#D93030"
                  />
                  <path
                    class="stroke"
                    d="M27 14V5C27 4.44772 26.5523 4 26 4H6C5.44772 4 5 4.44772 5 5V27C5 27.5523 5.44772 28 6 28H23.5"
                    stroke="#D93030"
                    stroke-width="1.5"
                    stroke-linecap="round"
                  />
                  <path
                    class="stroke"
                    d="M9 9H23"
                    stroke="#D93030"
                    stroke-width="1.5"
                    stroke-linecap="round"
                  />
                  <path
                    class="stroke"
                    d="M9 15H15"
                    stroke="#D93030"
                    stroke-width="1.5"
                    stroke-linecap="round"
                  />
                  <path
                    class="stroke"
                    d="M9 21H13.5"
                    stroke="#D93030"
                    stroke-width="1.5"
                    stroke-linecap="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_2190_36580">
                    <rect width="32" height="32" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              <span>Каталог</span>
              <svg
                class="arrow"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  class="stroke"
                  d="M10 17L15 12L10 7"
                  stroke="black"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </router-link>
          </li>
          <li>
            <router-link
              class="side-menu__nav__item"
              @click="$emit('closeMenu')"
              :to="{ name: 'order-history' }"
            >
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  class="stroke"
                  d="M3 8H6.26541C7.26071 8 8.10455 8.73186 8.24531 9.71716L9.38673 17.7071C9.73862 20.1704 11.8482 22 14.3365 22H25"
                  stroke="#D93030"
                  stroke-width="1.5"
                  stroke-linecap="round"
                />
                <circle
                  class="stroke"
                  cx="12.5"
                  cy="26.5"
                  r="1.75"
                  stroke="#D93030"
                  stroke-width="1.5"
                />
                <circle
                  class="stroke"
                  cx="22.5"
                  cy="26.5"
                  r="1.75"
                  stroke="#D93030"
                  stroke-width="1.5"
                />
                <path
                  class="stroke"
                  d="M8.5 12H24.7802C25.4112 12 25.8845 12.5773 25.7608 13.1961L25.1608 16.1961C25.0673 16.6635 24.6569 17 24.1802 17H9.5"
                  stroke="#D93030"
                  stroke-width="1.5"
                  stroke-linecap="round"
                />
                <path
                  class="stroke"
                  d="M14.5 6.5L17 9L22 4"
                  stroke="#D93030"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <span>Мои заказы</span>
              <svg
                class="arrow"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  class="stroke"
                  d="M10 17L15 12L10 7"
                  stroke="black"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </router-link>
          </li>
          <li>
            <router-link
              class="side-menu__nav__item"
              @click="$emit('closeMenu')"
              :to="{ name: 'profile' }"
            >
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  class="fill"
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M3.75 13.5C3.75 12.3835 3.93765 11.3109 4.28314 10.3119C4.29288 10.3123 4.30267 10.3125 4.3125 10.3125H8.17338C7.71303 12.406 7.71303 14.594 8.17338 16.6875H4.3125C4.30267 16.6875 4.29288 16.6877 4.28314 16.6881C3.93765 15.6891 3.75 14.6165 3.75 13.5ZM8.58825 8.8125H4.94866C6.2784 6.39183 8.60607 4.59689 11.3777 3.98164C10.1064 5.40768 9.17657 7.05816 8.58825 8.8125ZM10.1816 8.8125C10.8706 6.99967 11.9767 5.33082 13.5 3.9803C15.0233 5.33082 16.1294 6.99967 16.8184 8.8125H10.1816ZM16.4698 10.3125C16.7304 9.29999 17.2598 8.39541 17.9775 7.6794C17.4011 6.34807 16.616 5.09629 15.6223 3.98164C17.3295 4.3606 18.8682 5.18712 20.1091 6.33176C20.6671 6.13303 21.2648 6.01805 21.8872 6.00196C19.8271 3.69926 16.8328 2.25 13.5 2.25C7.2868 2.25 2.25 7.2868 2.25 13.5C2.25 19.7132 7.2868 24.75 13.5 24.75C13.9368 24.75 14.3678 24.7251 14.7917 24.6767L15.401 20.8803C14.8629 21.6537 14.2293 22.3732 13.5 23.0197C11.9767 21.6692 10.8706 20.0003 10.1816 18.1875H15.8701C16.0415 17.6218 16.3328 17.1129 16.7126 16.6875H9.71384C9.19954 14.6023 9.19954 12.3977 9.71384 10.3125H16.4698ZM17.425 16.0585C17.4717 15.8195 17.5118 15.5792 17.5452 15.3381C17.664 15.4866 17.79 15.6292 17.9227 15.7652C17.7495 15.8511 17.5832 15.9492 17.425 16.0585ZM8.58825 18.1875C9.17657 19.9418 10.1064 21.5923 11.3777 23.0184C8.60607 22.4031 6.2784 20.6082 4.94866 18.1875H8.58825Z"
                  fill="#D93030"
                />
                <circle
                  class="stroke"
                  cx="23"
                  cy="12"
                  r="4.25"
                  stroke="#D93030"
                  stroke-width="1.5"
                />
                <path
                  class="stroke"
                  d="M17 27L17.6398 20.602C17.8443 18.5572 19.5649 17 21.62 17H23H24.38C26.4351 17 28.1557 18.5572 28.3602 20.602L29 27"
                  stroke="#D93030"
                  stroke-width="1.5"
                  stroke-linecap="round"
                />
              </svg>
              <span>Профиль</span>
              <svg
                class="arrow"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  class="stroke"
                  d="M10 17L15 12L10 7"
                  stroke="black"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </router-link>
          </li>
          <li>
            <router-link
              class="side-menu__nav__item"
              @click="$emit('closeMenu')"
              :to="{ name: 'documents' }"
            >
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  class="stroke"
                  d="M5 27V7C5 6.44772 5.44772 6 6 6H22C22.5523 6 23 6.44772 23 7V27C23 27.5523 22.5523 28 22 28H6C5.44772 28 5 27.5523 5 27Z"
                  stroke="#D93030"
                  stroke-width="1.5"
                  stroke-linecap="round"
                />
                <path
                  class="stroke"
                  d="M9 6V4C9 3.44772 9.44772 3 10 3H26C26.5523 3 27 3.44772 27 4V24C27 24.5523 26.5523 25 26 25H23"
                  stroke="#D93030"
                  stroke-width="1.5"
                  stroke-linecap="round"
                />
                <path
                  class="stroke"
                  d="M8 11H20"
                  stroke="#D93030"
                  stroke-width="1.5"
                  stroke-linecap="round"
                />
                <path
                  class="stroke"
                  d="M8 17H20"
                  stroke="#D93030"
                  stroke-width="1.5"
                  stroke-linecap="round"
                />
                <path
                  class="stroke"
                  d="M8 23H20"
                  stroke="#D93030"
                  stroke-width="1.5"
                  stroke-linecap="round"
                />
              </svg>
              <span>Документы</span>
              <svg
                class="arrow"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  class="stroke"
                  d="M10 17L15 12L10 7"
                  stroke="black"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </router-link>
          </li>
          <li>
            <router-link
              class="side-menu__nav__item"
              @click="$emit('closeMenu')"
              :to="{ name: 'payments' }"
            >
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  class="stroke"
                  d="M27 16V12C27 11.4477 26.5523 11 26 11H6C5.44772 11 5 11.4477 5 12V26C5 26.5523 5.44772 27 6 27H26C26.5523 27 27 26.5523 27 26V22.5"
                  stroke="#D93030"
                  stroke-width="1.5"
                  stroke-linecap="round"
                />
                <path
                  class="stroke"
                  d="M20.7031 16.4453L19.3698 18.4453C19.1459 18.7812 19.1459 19.2188 19.3698 19.5547L20.7031 21.5547C20.8886 21.8329 21.2008 22 21.5352 22H28C28.5523 22 29 21.5523 29 21V17C29 16.4477 28.5523 16 28 16H21.5352C21.2008 16 20.8886 16.1671 20.7031 16.4453Z"
                  stroke="#D93030"
                  stroke-width="1.5"
                  stroke-linecap="round"
                />
                <path
                  class="stroke"
                  d="M12 11L21.1824 5.49058C21.6401 5.21595 22.2328 5.34923 22.5289 5.79337L26 11"
                  stroke="#D93030"
                  stroke-width="1.5"
                  stroke-linecap="round"
                />
                <path
                  class="stroke"
                  d="M10 11L16.2929 4.70711C16.6834 4.31658 17.3166 4.31658 17.7071 4.70711L19 6"
                  stroke="#D93030"
                  stroke-width="1.5"
                  stroke-linecap="round"
                />
                <path
                  class="stroke"
                  d="M8 11L10.5822 4.9748C10.8089 4.44595 11.434 4.21698 11.9486 4.47429L15 6"
                  stroke="#D93030"
                  stroke-width="1.5"
                  stroke-linecap="round"
                />
                <circle class="fill" cx="23" cy="19" r="1" fill="#D93030" />
              </svg>
              <span>Платежи</span>
              <svg
                class="arrow"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  class="stroke"
                  d="M10 17L15 12L10 7"
                  stroke="black"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </router-link>
          </li>
          <li>
            <router-link
              class="side-menu__nav__item"
              @click="$emit('closeMenu')"
              :to="{ name: 'analitics' }"
            >
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  class="stroke"
                  d="M3 29H29"
                  stroke="#D93030"
                  stroke-width="1.5"
                  stroke-linecap="round"
                />
                <path
                  class="stroke"
                  d="M11 29V13C11 12.4477 10.5523 12 10 12H7C6.44772 12 6 12.4477 6 13V29"
                  stroke="#D93030"
                  stroke-width="1.5"
                />
                <path
                  class="stroke"
                  d="M19 29V21C19 20.4477 18.5523 20 18 20H15C14.4477 20 14 20.4477 14 21V29"
                  stroke="#D93030"
                  stroke-width="1.5"
                />
                <path
                  class="stroke"
                  d="M27 29V18C27 17.4477 26.5523 17 26 17H23C22.4477 17 22 17.4477 22 18V29"
                  stroke="#D93030"
                  stroke-width="1.5"
                />
                <circle
                  class="stroke"
                  cx="8.5"
                  cy="6.5"
                  r="1.75"
                  stroke="#D93030"
                  stroke-width="1.5"
                />
                <circle
                  class="stroke"
                  cx="16.5"
                  cy="14.5"
                  r="1.75"
                  stroke="#D93030"
                  stroke-width="1.5"
                />
                <circle
                  class="stroke"
                  cx="24.5"
                  cy="11.5"
                  r="1.75"
                  stroke="#D93030"
                  stroke-width="1.5"
                />
                <path
                  class="stroke"
                  d="M10 8L15 13"
                  stroke="#D93030"
                  stroke-width="1.5"
                  stroke-linecap="round"
                />
                <path
                  class="stroke"
                  d="M18.5 14L22.5 12.5"
                  stroke="#D93030"
                  stroke-width="1.5"
                  stroke-linecap="round"
                />
              </svg>
              <span>Аналитика</span>
              <svg
                class="arrow"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  class="stroke"
                  d="M10 17L15 12L10 7"
                  stroke="black"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </router-link>
          </li>
          <li>
            <router-link
              class="side-menu__nav__item"
              @click="$emit('closeMenu')"
              :to="{ name: 'marketingPages' }"
            >
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  class="stroke"
                  d="M15 11V21M15 11C19 10 22 10 27 6V26C22 22 19 22 15 21M15 11L6.88957 11.9012C6.38313 11.9574 6 12.3855 6 12.895V19.105C6 19.6145 6.38314 20.0426 6.88957 20.0988L15 21"
                  stroke="#D93030"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  class="stroke"
                  d="M6 14H4C3.44772 14 3 14.4477 3 15V18C3 18.5523 3.44772 19 4 19H6"
                  stroke="#D93030"
                  stroke-width="1.5"
                  stroke-linecap="round"
                />
                <path
                  class="stroke"
                  d="M9 20.5L10.802 27.2577C10.9188 27.6954 11.3152 28 11.7683 28H15L13 21"
                  stroke="#D93030"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <span>Маркетинг</span>
              <svg
                class="arrow"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  class="stroke"
                  d="M10 17L15 12L10 7"
                  stroke="black"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </router-link>
          </li>
          <li>
            <router-link
              class="side-menu__nav__item"
              @click="$emit('closeMenu')"
              :to="{ name: 'knowledge' }"
            >
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  class="stroke"
                  d="M23.25 11C23.25 13.7405 22.1318 15.3222 20.9144 16.844C20.8212 16.9605 20.7264 17.0775 20.6309 17.1955C19.617 18.4477 18.5217 19.8006 18.2933 21.75H11.7069C11.4785 19.8006 10.3831 18.4477 9.36915 17.1954C9.27367 17.0775 9.17893 16.9605 9.08569 16.844C7.86824 15.3222 6.75 13.7405 6.75 11C6.75 8.95097 7.43983 6.88358 8.7996 5.33867C10.1464 3.80855 12.1847 2.75 14.9847 2.75C17.785 2.75 19.8317 3.80884 21.1864 5.34009C22.5537 6.88572 23.25 8.95292 23.25 11Z"
                  stroke="#D93030"
                  stroke-width="1.5"
                />
                <rect
                  class="stroke"
                  x="10.75"
                  y="22.25"
                  width="8.5"
                  height="2.5"
                  rx="1.25"
                  stroke="#D93030"
                  stroke-width="1.5"
                />
                <rect
                  class="stroke"
                  x="10.75"
                  y="25.25"
                  width="8.5"
                  height="2.5"
                  rx="1.25"
                  stroke="#D93030"
                  stroke-width="1.5"
                />
                <path
                  class="stroke"
                  d="M13 28V28C13 29.1046 13.8954 30 15 30V30C16.1046 30 17 29.1046 17 28V28"
                  stroke="#D93030"
                  stroke-width="1.5"
                  stroke-linecap="round"
                />
                <path
                  class="stroke"
                  d="M14 22V11C14 10.4477 13.5523 10 13 10V10C12.4477 10 12 10.4477 12 11V11C12 11.5523 12.4477 12 13 12H17C17.5523 12 18 11.5523 18 11V11C18 10.4477 17.5523 10 17 10V10C16.4477 10 16 10.4477 16 11V22"
                  stroke="#D93030"
                  stroke-linecap="round"
                />
              </svg>
              <span>База знаний</span>
              <svg
                class="arrow"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  class="stroke"
                  d="M10 17L15 12L10 7"
                  stroke="black"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </router-link>
          </li>
          <li>
            <router-link
              class="side-menu__nav__item"
              @click="$emit('closeMenu')"
              :to="{ name: 'support' }"
            >
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  class="stroke"
                  d="M19.5 21.5064C20.3795 21.3228 21.2173 21.0605 22 20.7298L26 23L25.7008 18.25C27.1445 16.7615 28 14.9112 28 12.9062C28 7.98746 22.8513 4 16.5 4C10.1487 4 5 7.98746 5 12.9062C5 14.5071 5.54534 16.0092 6.5 17.3074"
                  stroke="#D93030"
                  stroke-width="1.5"
                />
                <path
                  class="stroke"
                  d="M6.13344 24.2234L6.39386 24.4875L6.34206 24.8547L5.95479 27.6006L8.63163 26.0912L8.91267 25.9328L9.22099 26.0278C10.0748 26.2911 11.0129 26.4375 12 26.4375C14.0598 26.4375 15.8966 25.8007 17.2024 24.8061C18.5075 23.8119 19.25 22.4925 19.25 21.0938C19.25 19.695 18.5075 18.3756 17.2024 17.3814C15.8966 16.3868 14.0598 15.75 12 15.75C9.94019 15.75 8.10336 16.3868 6.79761 17.3814C5.49247 18.3756 4.75 19.695 4.75 21.0938C4.75 22.2371 5.24378 23.3212 6.13344 24.2234Z"
                  stroke="#D93030"
                  stroke-width="1.5"
                />
                <circle class="fill" cx="9" cy="21" r="1" fill="#D93030" />
                <circle class="fill" cx="12" cy="21" r="1" fill="#D93030" />
                <circle class="fill" cx="15" cy="21" r="1" fill="#D93030" />
              </svg>
              <span>Поддержка</span>
              <svg
                class="arrow"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  class="stroke"
                  d="M10 17L15 12L10 7"
                  stroke="black"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </router-link>
          </li>
          <li>
            <router-link
              class="side-menu__nav__item"
              @click="$emit('closeMenu')"
              :to="{ name: 'questions' }"
            >
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  class="fill"
                  d="M7 25.3956H6.25V26.1456H7V25.3956ZM29.5552 23.1749L29.3777 22.4462L29.5552 23.1749ZM7 19.1451L6.99997 18.3951L6.25 18.3951V19.1451H7ZM14.8861 20.4904C14.5391 20.2643 14.0744 20.3622 13.8483 20.7092C13.6221 21.0563 13.7201 21.5209 14.0671 21.7471L14.8861 20.4904ZM20.8529 24.4666L21.1633 25.1493L20.8529 24.4666ZM7 26.1456C9.79438 26.1456 11.3207 26.7556 12.8298 27.3893C14.3954 28.0467 15.9808 28.75 18.749 28.75V27.25C16.2979 27.25 14.9461 26.6511 13.4106 26.0063C11.8187 25.3378 10.0801 24.6456 7 24.6456V26.1456ZM18.749 28.75C20.6606 28.75 22.44 27.6762 24.133 26.6295C25.8929 25.5414 27.6585 24.4088 29.7327 23.9036L29.3777 22.4462C27.0272 23.0187 25.0508 24.2986 23.3442 25.3536C21.5708 26.4501 20.1596 27.25 18.749 27.25V28.75ZM29.7327 23.9036C30.2432 23.7792 30.5998 23.4063 30.7122 22.9283C30.8156 22.4882 30.6983 22.0383 30.4778 21.6731C30.022 20.9181 29.0604 20.3688 27.7452 20.3688V21.8688C28.6487 21.8688 29.0634 22.2326 29.1937 22.4483C29.2661 22.5684 29.2442 22.6182 29.252 22.5851C29.2687 22.5142 29.3385 22.4557 29.3777 22.4462L29.7327 23.9036ZM21.8077 21.7263C21.0051 20.9409 19.8988 19.9519 18.6583 19.1118C17.4292 18.2794 16.0055 17.5498 14.5754 17.3598L14.3778 18.8467C15.4711 18.9919 16.6662 19.5742 17.8172 20.3538C18.9569 21.1256 19.9922 22.0485 20.7587 22.7984L21.8077 21.7263ZM14.5754 17.3598C13.5678 17.2259 12.8171 17.2221 12.1861 17.3071C11.551 17.3926 11.0721 17.564 10.6316 17.7313C9.81582 18.041 9.00601 18.395 6.99997 18.3951L7.00003 19.8951C9.26633 19.895 10.2713 19.4726 11.164 19.1336C11.5776 18.9766 11.9264 18.8556 12.3863 18.7937C12.8502 18.7312 13.4619 18.725 14.3778 18.8467L14.5754 17.3598ZM6.25 19.1451V25.3956H7.75V19.1451H6.25ZM19.8602 23.7323L14.8861 20.4904L14.0671 21.7471L19.0412 24.9889L19.8602 23.7323ZM27.7452 20.3688C25.3658 20.3688 23.792 21.0596 21.692 21.8287L22.2078 23.2372C24.3868 22.4392 25.6873 21.8688 27.7452 21.8688V20.3688ZM20.5425 23.7838C20.3212 23.8844 20.0639 23.865 19.8602 23.7323L19.0412 24.9889C19.6746 25.4017 20.475 25.4622 21.1633 25.1493L20.5425 23.7838ZM20.7587 22.7984C21.0439 23.0775 20.9863 23.5821 20.5425 23.7838L21.1633 25.1493C22.4856 24.5482 22.9092 22.804 21.8077 21.7263L20.7587 22.7984Z"
                  fill="#D93030"
                />
                <path
                  class="stroke"
                  d="M18.5 19.2698C19.6665 17.9782 21.5093 17.4341 22.1107 18.7855C23.7957 17.4939 24.703 18.3011 24.5733 19.2698C25.8384 18.8837 27.4005 19.2699 26.9064 21"
                  stroke="#D93030"
                  stroke-width="1.5"
                />
                <path
                  class="stroke"
                  d="M6 18H4C3.44772 18 3 18.4477 3 19V25C3 25.5523 3.44772 26 4 26H6C6.55228 26 7 25.5523 7 25V19C7 18.4477 6.55228 18 6 18Z"
                  stroke="#D93030"
                  stroke-width="1.5"
                  stroke-linejoin="round"
                />
                <path
                  class="stroke"
                  d="M15 7V7C15 5.34315 16.3431 4 18 4H18.0688C19.6876 4 21 5.31236 21 6.93125V6.93125C21 7.91132 20.5102 8.82654 19.6947 9.37019L19.5 9.5C18.5629 10.1247 18 11.1765 18 12.3028V12.5"
                  stroke="#D93030"
                  stroke-width="1.5"
                  stroke-linecap="round"
                />
                <circle class="fill" cx="18" cy="15" r="1" fill="#D93030" />
              </svg>
              <span>Вопросы и предложения</span>
              <svg
                class="arrow"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  class="stroke"
                  d="M10 17L15 12L10 7"
                  stroke="black"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </router-link>
          </li>
        </ul>
      </nav>
      <router-link
        class="side-menu__special-btn"
        @click="$emit('closeMenu')"
        :to="{ name: 'special-order' }"
        >Специальный заказ</router-link
      >
      <a :href="storeSideBanner.link">
        <!-- <img
          v-if="storeSideBanner.banner != ''"
          class="side-menu__banner"
          :src="storeSideBanner.banner"
          alt="banner"
        /> -->
        <img v-if="false" class="side-menu__banner" :src="storeSideBanner.banner" alt="banner" />
        <div v-else class="side-menu__banner side-menu__banner_placeholder" />
      </a>
      <div class="side-menu__bottom">
        <a href="tel:88003332590">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10 17.6953C9.56848 17.6953 9.21875 17.3456 9.21875 16.9141C9.21875 16.4825 9.56848 16.1328 10 16.1328C10.4315 16.1328 10.7812 16.4825 10.7812 16.9141C10.7812 17.3456 10.4315 17.6953 10 17.6953ZM15.8203 11.4062C16.2518 11.4062 16.6016 11.0565 16.6016 10.625V3.125C16.6016 1.40182 15.1997 0 13.4766 0H6.52344C4.80026 0 3.39844 1.40182 3.39844 3.125V16.875C3.39844 18.5982 4.80026 20 6.52344 20H13.4766C15.1997 20 16.6016 18.5982 16.6016 16.875V14.5312C16.6016 14.0997 16.2518 13.75 15.8203 13.75H7.30469C6.87317 13.75 6.52344 14.0997 6.52344 14.5312C6.52344 14.9628 6.87317 15.3125 7.30469 15.3125H15.0391V16.875C15.0391 17.7365 14.3381 18.4375 13.4766 18.4375H6.52344C5.66193 18.4375 4.96094 17.7365 4.96094 16.875V3.125C4.96094 2.26349 5.66193 1.5625 6.52344 1.5625H13.4766C14.3381 1.5625 15.0391 2.26349 15.0391 3.125V10.625C15.0391 11.0565 15.3888 11.4062 15.8203 11.4062Z"
              fill="#D93030"
            />
          </svg>
          <p>8 800 333 25 90</p>
        </a>
        <a href="mailto:info@bwtool.ru">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M19 4H5C4.2 4 3.4 4.3 2.9 4.9C2.4 5.5 2 6.2 2 7V17C2 17.8 2.3 18.6 2.9 19.1C3.4 19.7 4.2 20 5 20H19C19.8 20 20.6 19.7 21.1 19.1C21.7 18.5 22 17.8 22 17V7C22 6.2 21.7 5.4 21.1 4.9C20.6 4.3 19.8 4 19 4ZM5 6H19C19.3 6 19.5 6.1 19.7 6.3C19.9 6.5 20 6.7 20 7L12 11.9L4 7C4 6.7 4.1 6.5 4.3 6.3C4.5 6.1 4.7 6 5 6ZM20 17C20 17.3 19.9 17.5 19.7 17.7C19.5 17.9 19.3 18 19 18H5C4.7 18 4.5 17.9 4.3 17.7C4.1 17.5 4 17.3 4 17V9.3L11.5 13.9C11.7 14 11.8 14 12 14C12.2 14 12.3 14 12.5 13.9L20 9.3V17Z"
              fill="#D93030"
            />
          </svg>
          <p>info@bwtool.ru</p>
        </a>
        <button @click="profileExit()">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15 4H7C5.89543 4 5 4.89543 5 6V18C5 19.1046 5.89543 20 7 20H15"
              stroke="#D93030"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M16 15L19 12M19 12L16 9M19 12H9"
              stroke="#D93030"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <p>Выйти</p>
        </button>
      </div>
    </div>
  </aside>
</template>

<script>
import { mapState } from 'pinia'
import { useGeneralInfo } from '../stores/generalInfo'
import { useUserToken } from '@/stores/userToken'

export default {
  name: 'SideMenu',

  setup() {},

  props: {
    menuOpen: {
      type: Boolean,
      default() {
        return false
      }
    }
  },

  emits: ['closeMenu'],

  data() {
    return {}
  },

  computed: {
    ...mapState(useGeneralInfo, { storeSideBanner: 'sideBanner' }),
    ...mapState(useUserToken, { storeFirstProfileEnter: 'firstProfileEnter' }),

    isProfileRegistration() {
      if (this.storeFirstProfileEnter) {
        return true
      } else {
        return false
      }
    }
  },

  methods: {}
}
</script>

<style lang="scss">
.side-menu {
  max-width: 280px;
  width: 100%;

  $p: &;

  &__header {
    display: none;
    align-items: center;
    justify-content: space-between;

    p {
      @extend %text-medium;
    }
  }

  &__nav {
    width: 100%;

    li:first-of-type {
      .side-menu__nav__item {
        border-radius: 6px 6px 0 0;
      }
    }

    li:last-of-type {
      .side-menu__nav__item {
        border-radius: 0 0 6px 6px;
      }
    }

    &__item {
      width: 100%;

      display: flex;
      align-items: center;

      height: 56px;

      padding: 0 24px;

      background-color: var(--bw6);

      transition: background-color 0.3s;

      span {
        @extend %text-regular;
        color: var(--bw0);

        margin-left: 12px;
      }

      .arrow {
        margin-left: auto;

        transition: transform 0.3s;
      }

      &:hover {
        background-color: var(--bw3);

        .arrow {
          transform: translateX(5px);
        }
      }

      &.router-link-active {
        background-color: var(--bw1);

        span {
          color: var(--bw6);
        }

        pointer-events: none;

        svg {
          .stroke {
            stroke: var(--bw6);
          }

          .fill {
            fill: var(--bw6);
          }
        }
      }

      &.catalog {
        &.router-link-active {
          pointer-events: all;
        }

        &.router-link-exact-active {
          pointer-events: none;
        }
      }
    }

    &.registration {
      .side-menu__nav__item {
        opacity: 0.4;
        pointer-events: none;

        &.router-link-active {
          opacity: 1;
        }
      }
    }
  }

  &__special-btn {
    @extend %button;

    margin-top: 24px;
  }

  &__banner {
    width: 280px;
    height: 587px;

    object-fit: cover;

    margin-top: 32px;

    border-radius: 6px;

    &_placeholder {
      background-color: $bw3;
    }
  }

  &__bottom {
    display: none;

    a,
    button {
      display: flex;
      align-items: center;
      column-gap: 12px;

      background-color: transparent;

      svg {
        width: 24px;
      }

      p {
        @extend %text-regular;
        color: var(--bw0);
      }
    }
  }
}

@media screen and (max-width: 1600px) {
  .side-menu {
    max-width: 240px;

    &__nav {
      &__item {
        height: 52px;

        span {
          max-width: 150px;
        }
      }
    }

    &__special-btn {
      margin-top: 16px;
    }

    &__banner {
      margin-top: 24px;

      width: 240px;
      height: 500px;
    }
  }
}

@media screen and (max-width: 1300px) {
  .side-menu {
    position: fixed;
    top: 0;
    right: 0;

    border-radius: 6px 0 0 6px;

    z-index: 10;

    height: 100vh;

    max-width: 380px;

    transform: translateX(100%);

    transition: transform 0.5s;

    &.open {
      transform: translateX(0);

      .side-menu__bg {
        transform: translateX(0);
        display: block;
      }
    }

    &__wrapper {
      background-color: $bw6;

      padding: 32px 0;
      height: 100%;
      overflow-y: scroll;

      position: relative;

      z-index: 5;

      &::-webkit-scrollbar {
        width: 6px;
        /* ширина всей полосы прокрутки */
      }

      &::-webkit-scrollbar-track {
        background: $bw4;
        /* цвет зоны отслеживания */
      }

      &::-webkit-scrollbar-thumb {
        background-color: $primary;
        /* цвет бегунка */
        border-radius: 10px;
        /* округлось бегунка */
        border: none;
        /* отступ вокруг бегунка */
      }
    }

    &__header {
      display: flex;
      padding: 0 24px;

      position: relative;

      z-index: 5;
    }

    &__banner {
      display: none;
    }

    &__nav {
      margin-top: 16px;

      &__item {
        padding: 0 24px;

        height: 56px;

        span {
          max-width: 100%;
        }
      }
    }

    &__special-btn {
      margin-left: 24px;
      margin-right: 24px;
      width: auto;
    }

    &__bottom {
      margin-top: 32px;
      display: flex;
      flex-direction: column;
      row-gap: 16px;

      padding: 0 24px;

      button {
        p {
          color: $primary;
        }
      }
    }
  }
}

@media screen and (max-width: 800px) {
  .side-menu {
    width: 100vw;
    max-width: 100vw;

    &__nav {
      li:first-of-type {
        .side-menu__nav__item {
          border-radius: 0;
        }
      }

      li:last-of-type {
        .side-menu__nav__item {
          border-radius: 0;
        }
      }
    }
  }
}
</style>
